// extracted by mini-css-extract-plugin
export default {"dropdownGroup":"style_dropdownGroup__xNvzt"};